import React from "react";
import { Switch } from "../ui/switch";
import { useRealtimeStore } from "@/lib/store/Realtime";

export const UnreadFilterToggle: React.FC = () => {
	const { showOnlyUnread, setShowOnlyUnread } = useRealtimeStore((state) => ({
		showOnlyUnread: state.showOnlyUnread,
		setShowOnlyUnread: state.setShowOnlyUnread,
	}));

	return (
		<div className="flex items-center gap-2">
			<label
				htmlFor="unread-filter"
				className="text-sm font-medium text-gray-700 cursor-pointer"
			>
				Ungelesen
			</label>
			<Switch
				id="unread-filter"
				checked={showOnlyUnread}
				onCheckedChange={setShowOnlyUnread}
				className="data-[state=checked]:bg-blue-600"
			/>
		</div>
	);
};